import { createTheme } from '@mantine/core';
import { brandColors } from './brand';

/**
 * Theme overrides live here rather than being scattered across components, so
 * the visual language changes in one place.
 *
 * Component defaults are set here too. Before this existed the two Card usages
 * in the app had already drifted apart — one `padding="xl"`, one `padding="md"`
 * — which is what a design system is for.
 */
export const theme = createTheme({
  colors: brandColors,
  primaryColor: 'brand',
  // Shade 6 is the sampled brand blue: right on white, too dark to read on a
  // navy surface. Dark mode steps one shade lighter.
  primaryShade: { light: 6, dark: 5 },
  defaultRadius: 'md',
  fontFamily:
    '"Inter Variable", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  headings: {
    fontWeight: '650',
    sizes: {
      h1: { fontSize: '1.875rem', lineHeight: '1.2' },
      h2: { fontSize: '1.5rem', lineHeight: '1.25' },
      h3: { fontSize: '1.25rem', lineHeight: '1.3' },
      h4: { fontSize: '1.0625rem', lineHeight: '1.35' },
    },
  },
  components: {
    Card: {
      defaultProps: { withBorder: true, padding: 'lg', radius: 'md' },
    },
    Paper: {
      defaultProps: { radius: 'md' },
    },
    Button: {
      defaultProps: { radius: 'md' },
    },
    NavLink: {
      defaultProps: { variant: 'light' },
    },
    Alert: {
      defaultProps: { variant: 'light', radius: 'md' },
    },
    Badge: {
      defaultProps: { radius: 'sm' },
    },
  },
});
